"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeNetworkManager = void 0;
class FakeNetworkManager {
    constructor() {
        this.socketConnected = true;
    }
    registerSocketConnectListener() {
        throw new Error("Method not implemented.");
    }
    registerSocketDisconnectListener() {
        throw new Error("Method not implemented.");
    }
    registerSocketAuthSuccessListener() {
        const noOp = () => { };
        return noOp;
    }
    registerSocketAuthStatusListener() {
        const noOp = () => { };
        return noOp;
    }
    init() {
        throw new Error("Method not implemented.");
    }
    destroy() {
        throw new Error("Method not implemented.");
    }
    isSocketConnected() {
        return this.socketConnected;
    }
    registerSocketStatusListener() {
        const noOp = () => { };
        return noOp;
    }
    getLastSocketHeartbeatTime() {
        throw new Error("Method not implemented.");
    }
    getInternetStatus() {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setInternetStatus(status) {
        throw new Error("Method not implemented.");
    }
}
exports.FakeNetworkManager = FakeNetworkManager;
